module.exports = __webpack_public_path__ + "img/thumb-barabara-off.5a643dec.jpg";